import { Chip, ChipProps } from '@mui/material';
import styled from 'styled-components';

interface StyledChipProps extends ChipProps {
  $allCaps?: boolean,
  $cursorType?: 'default' | 'pointer',
}

const StyledChip = styled(Chip)<StyledChipProps>`
&& {
  text-transform: ${({ $allCaps }) => ($allCaps ? 'uppercase' : 'none')};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  cursor: ${({ $cursorType }) => $cursorType || 'default'};
}
`;

export { StyledChip };
